import React from 'react';

import {TChannelType} from 'src/constants';
import {useLeadTechPartnerCheck} from 'src/containers/LeadCompanyClients/useLeadTechPartnerCheck';

import {BaseTariffSelect} from './BaseTariffSelect';
import {SellingTariffSelectField} from './SellingTariffSelect';

type TProps = {
  channelType: TChannelType;
  name: string;
  readOnly?: boolean;
  disabled?: boolean;
};

export const TariffSelectField = React.memo<TProps>(({name, channelType, disabled, readOnly}) => {
  const {isTechPartner, isTechPartnerLoading} = useLeadTechPartnerCheck();
  const TariffField = readOnly || isTechPartner ? BaseTariffSelect : SellingTariffSelectField;

  if (isTechPartnerLoading) {
    return null;
  }

  return (
    <TariffField name={name} channelType={channelType} disabled={disabled} readOnly={readOnly} />
  );
});

TariffSelectField.displayName = 'TariffSelectField';
